import React from 'react'
import PersonalSpaceMolecule from '../../../molecules/PersonalSpace'

function PersonalSpace (props) {
  return <PersonalSpaceMolecule {...props} />
}

export default PersonalSpace
